import assets from '../../journey/assets';
import { AssetContext as ArticaAssetContext } from '@artica/assets';

const keys = Object.keys(assets.all);

export default function AssetContext({ children }) {
  return (
    <ArticaAssetContext keys={ keys }>
      { children }
    </ArticaAssetContext>
  );
};